export default {"src":"https://marketing-edge-assets.lemonade.com/_next/static/media/breaks.e728dd45.svg","height":69,"width":69,"blurWidth":0,"blurHeight":0};